import { useEffect, useMemo } from "react";
import { StickyBar, MobileBar } from "../components/v2/StickyBar";
import { HeroV2 } from "../components/v2/HeroV2";
import { LearnSection, FitSection, AboutSection, TestimonialPlaceholder, FAQV2, FinalCTA, FooterV2 } from "../components/v2/SectionsV2";

export default function LandingV2() {
  const attribution = useMemo(() => {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get("utm_source"),
      utm_medium: p.get("utm_medium"),
      utm_campaign: p.get("utm_campaign"),
      utm_content: p.get("utm_content"),
      utm_term: p.get("utm_term"),
      fbclid: p.get("fbclid"),
      gclid: p.get("gclid"),
      pageUrl: window.location.href,
      referrer: document.referrer || null,
    };
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB] text-[#475467] pb-20 md:pb-0" data-testid="landing-v2">
      <StickyBar />
      <HeroV2 attribution={attribution} />
      <LearnSection />
      <FitSection />
      <AboutSection />
      <TestimonialPlaceholder />
      <FAQV2 />
      <FinalCTA />
      <FooterV2 />
      <MobileBar />
    </div>
  );
}
